import { FC } from "react";

export const Help:FC<any> = (props) => {

    const {comparativa,kpis,tabID,filtered} = props

    
    

    
    return (
        <div style={{height:'100%',width:'80%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'flex-start'}}>
            <div style={{display:'flex',flex:1,justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column',width:'100%'}}>
                <span style={{fontWeight:'bold',fontFamily:'var(--roboto-medium)',textAlign:'start',width:'100%',marginBottom:5}}>KPIS</span>
                <div style={tabID === 3? {height:'100%',width:'80%',display:'flex',justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column'} : {height:'100%',width:'80%',display:'flex',justifyContent:'center',alignItems:'flex-start',flexDirection:'column'}}>
                    {
                        kpis.map((kpi:any) => {
                            if(filtered) {
                                if(kpi.startsWith('**')) {
                                    return(
                                        <span style={{fontFamily:'var(-acciona-light)',fontSize:'0.65rem',paddingBottom:'0.5rem',color:'red'}}>{kpi}</span>
                                        )
                                } else {
                                    return(
                                        <span style={{fontFamily:'var(-acciona-light)',fontSize:'0.7rem',paddingBottom:'0.5rem'}}>{kpi}</span>
                                        )
                                }
                            } else {
                                if(!kpi.startsWith('**')) {
                                    return(
                                        <span style={{fontFamily:'var(-acciona-light)',fontSize:'0.7rem',paddingBottom:'0.5rem'}}>{kpi}</span>
                                        )
                                } 
                            }
                            
                        })
                    }
                </div>
            </div>
            <div style={tabID === 2 ? {display:'flex',flex:1.25,justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column',width:'100%'} : tabID === 3? {display:'flex',flex:1.5,justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column',width:'100%'} : (tabID === 4 || tabID === 5)? {display:'flex',flex:0.75,justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column',width:'100%'} : {display:'flex',flex:1,justifyContent:'flex-start',alignItems:'flex-start',flexDirection:'column',width:'100%'}}>
                <span style={{fontWeight:'bold',fontFamily:'var(--roboto-medium)',textAlign:'start',width:'100%',marginBottom:5}}>GRÁFICA</span>
                <div style={{height:'50%',width:'80%',display:'flex',justifyContent:'flex-start',alignItems:'flex-start'}}>
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'50%',height:'100%',flexDirection:'column'}}>
                        <div style={{minHeight:50,minWidth:20,backgroundColor:'rgba(10,10,44,0.3)',borderTopLeftRadius:5,borderTopRightRadius:5}}>
                        </div>
                        <span style={{fontFamily:'var(--roboto-light)',fontSize:'0.8rem'}}>Real</span>
                    </div>
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'50%',height:'100%',flexDirection:'column'}}>
                        <div style={comparativa? {minHeight:50,minWidth:20,background: `linear-gradient(to bottom, var(--lis-dark) 50%, var(--lis-alternative) 50%)`,borderTopLeftRadius:5,borderTopRightRadius:5} : {minHeight:50,minWidth:20,background: `var(--lis-dark)`,borderTopLeftRadius:5,borderTopRightRadius:5}}>

                        </div>
                        <span style={{fontFamily:'var(--roboto-light)',fontSize:'0.8rem'}}>Planificado</span>
                        </div>
                    </div>
                    <div style={{width:'80%',display:'flex',justifyContent:'center',alignItems:'flex-start',flexDirection:'column'}}>
                        <span style={{fontFamily:'var(-acciona-light)',fontSize:'0.7rem'}}>
                            Para los meses donde inicia la planificación, se indica qué parte del mes es real, y cuál es planificada.
                        </span>
                    </div>
            </div>
        </div>
    )
}